// Supabase client. Reads URL + publishable key from env.
//
// In Phase 3 the SupabaseStore will use this client for both queries and
// realtime channels. For now it just provides the auth surface — once Phase 2
// dashboard config is done, the login UI lights up.
import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. ' +
    'Copy .env.example to .env.local and fill in the values from Supabase → Settings → API.',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    // PKCE flow — the OAuth callback redirects with a short-lived,
    // single-use `?code=...` query param that the SDK exchanges server-side
    // for tokens. Avoids the implicit-flow pattern where access + refresh
    // tokens land in the URL fragment (visible in browser history, leaks
    // on copy/paste, readable by tab-permissioned extensions). The
    // post-exchange URL cleanup happens in App.tsx via replaceState so
    // even the `?code=...` doesn't linger after sign-in.
    flowType: 'pkce',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
